// app/pages/profileMembers/components/ProfileMemberLanguages.tsx
import {FC} from 'react'

interface ProfileMemberLanguagesProps {
  languages: string[]
}

export const ProfileMemberLanguages: FC<ProfileMemberLanguagesProps> = ({languages}) => {
  return (
    <div className='nb-pm-languages'>
      <div className='nb-pm-languages-inner w-auto'>
        <div className='nb-pm-languages-title'>Language Spoken</div>
        <div className='biography__languages-list'>
          {(languages ?? []).map((item, index) => (
            <div key={index} className='lang'>
              {item}
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}